import React, { useEffect, useState } from "react"
import { CountrySelector } from "./CountrySelector"
import { MobileNumberInput } from "./MobileNumberInput"
import { OtpInput } from "./OtpInput"
import { Button } from "./Button"
import { TimerDisplay } from "./TimerDisplay"
import { useDispatch, useSelector } from "react-redux"
import { getOTPRequest, loginRequest } from "../../redux/actions/auth"
import { useNavigate } from "react-router-dom"
import { GET_OTP_RESET, LOGIN_RESET } from "../../redux/types/auth"
import { toast } from "react-toastify"
import ErrorPopup from "components/ErrorPopup"

export const LoginForm = props => {
  
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  const [selectedCountry, setSelectedCountry] = useState("IN")
  const [mobileNumber, setMobileNumber] = useState("")
  const [otp, setOtp] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [showOtpInput, setShowOtpInput] = useState(false)
  const [isNumberLocked, setIsNumberLocked] = useState(false)
  const [countdown, setCountdown] = useState(0)

  const getOTPScreen = useSelector(state => state.screens.getOTP)
  const loginScreen = useSelector(state => state.screens.login)
  const user = useSelector(state => state.auth.user)

  useEffect(() => {
    if (getOTPScreen.success) {
      setShowOtpInput(true)
      setIsNumberLocked(true)
      setCountdown(60)
      dispatch({ type: GET_OTP_RESET })
    }

    if (loginScreen.success) {
      setIsNumberLocked(false)
      setShowOtpInput(false)
      setOtp("")
      setCountdown(0)
      dispatch({ type: LOGIN_RESET })
      if (props.state && props.state.from) {
        navigate(props.state.from, { replace: true })
      } else {
        if (user && (user.user_type == "admin" || user.user_type == "staff")) {
          navigate("/dashboard", { replace: true })
        } else if (user && user.user_type == "volunteer") {
          navigate("/volunteer/bazaars", { replace: true })
        } else navigate("/home", { replace: true })
      }
    }

    if (loginScreen.error) {
      toast.error(loginScreen.error || "Login failed. Please try again.")
      dispatch({ type: LOGIN_RESET })
    }
  }, [getOTPScreen, loginScreen])

  useEffect(() => {
    if (getOTPScreen.error) {
      toast.error(getOTPScreen.error || "An error occurred. Please try again.")
      props.switchToSignup(mobileNumber)
      // setMessage(
      //   getOTPScreen.error ||
      //     "An error occurred. Please try again or contact support."
      // )
      // setIsOpen(true)
    }
  }, [getOTPScreen])

  const handleGetOTP = e => {
    e.preventDefault()

    dispatch(getOTPRequest({ auth_type: "login", mobile_no: mobileNumber }))
  }

  const handleLogin = e => {
    e.preventDefault()
    dispatch(
      loginRequest({
        mobile_no: mobileNumber,
        mobile_otp: otp,
        login_with: "mobile",
      })
    )
  }

  const resendOTP = () => {
    dispatch(getOTPRequest({ mobile_no: mobileNumber }))
  }

  const handleEdit = () => {
    setIsNumberLocked(false)
    setShowOtpInput(false)
    setOtp("")
    setCountdown(0)
  }

  React.useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000)
      return () => clearTimeout(timer)
    }
  }, [countdown])

  const isGetOtpValid = mobileNumber.length === 10 && !showOtpInput
  const isLoginValid = otp.length === 4 && showOtpInput

  return (
    <form
      onSubmit={showOtpInput ? handleLogin : handleGetOTP}
      className="login-form"
    >
      <fieldset className="form-fieldset">
        <legend className="sr-only">Mobile Number Authentication</legend>

        <div className="label-container">
          <label htmlFor="mobile-number" className="label">
            WhatsApp Number
          </label>
          {isNumberLocked && (
            <button type="button" onClick={handleEdit} className="edit-button">
              Edit
            </button>
          )}
        </div>

        <div
          className="input-group"
          role="group"
          aria-labelledby="mobile-input-group"
        >
          <span id="mobile-input-group" className="sr-only">
            Mobile number with country selector
          </span>

          <CountrySelector
            selectedCountry={selectedCountry}
            onCountryChange={setSelectedCountry}
            disabled={isNumberLocked}
          />

          <MobileNumberInput
            value={mobileNumber}
            onChange={setMobileNumber}
            disabled={isLoading || isNumberLocked}
          />
        </div>

        {showOtpInput && (
          <div className="otp-section">
            <label htmlFor="otp-input" className="otp-label">
              Enter the OTP that sent on your WhatsApp{" "}
              <span>
                <i className="ion ion-logo-whatsapp"></i>
              </span>
            </label>
            <OtpInput value={otp} onChange={setOtp} disabled={isLoading} />
            {countdown > 0 ? (
              <div className="otp-timer-container">
                <TimerDisplay seconds={countdown} />
              </div>
            ) : (
              <div className="otp-timer-container">
                <button
                  type="button"
                  onClick={resendOTP}
                  className="edit-button"
                >
                  Resend OTP
                </button>
              </div>
            )}
          </div>
        )}

        <div className="button-container">
          <Button
            type="submit"
            disabled={(!isGetOtpValid && !isLoginValid) || isLoading}
            variant={isGetOtpValid || isLoginValid ? "active" : "default"}
            aria-describedby="button-help"
          >
            {isLoading ? "Loading..." : showOtpInput ? "Login" : "Get OTP"}
          </Button>
          <div id="button-help" className="sr-only">
            {showOtpInput
              ? "Click to login with your OTP"
              : "Click to receive a one-time password on your WhatsApp number"}
          </div>
        </div>
      </fieldset>
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="System Under Development"
        message={isErrorMessage}
      />
    </form>
  )
}
